import React from 'react';
import {
  Component,
  PuzzleButton
} from "puzzle";
import { FILTER } from "../../Dashboard/Filters/Types";

type PROPS = {
  allFilters: FILTER[]
}
type STATE = { allFilters: FILTER[] }

class SavedFiltersDialog extends Component<PROPS, STATE> {

  moduleDidMount = () => {
    this.setState({ allFilters: this.props.allFilters });
  };

  /**
   * Deletes filter
   *
   * @param item
   */
  deleteFilter(item: FILTER) {
    this.dispatch('deleteFilter', '', {
      filterIndex: item.filterId,
      updateSavedFilterDialog: true
    });
  }

  /**
   * Opens filter in dialog edit mode
   *
   * @param item
   */
  editFilter(item: FILTER) {
    this.dispatch('openInEditModePrefilteredDashboard', '', {
      dashboardFilter: false,
      filterData: item,
      closeSavedFilterDialog: true
    });
  }

  /**
   * Adds filter to search bar and filters main grid
   *
   * @param item
   */
  onFilterNameClick = (item: FILTER) => {
    this.dispatch('openPrefilteredSubmissionList', '', {
      filter: item,
      closeSavedFilterDialog: true
    });
  };

  /**
   * Marks filter as favorite
   *
   * @param item
   * @param e
   */
  saveToLandingPage(item: FILTER, e: any) {
    e.stopPropagation();
    this.dispatch('updateFavoriteStatus', '', {
      isFavoriteData: {
        isFavorite: !item.isFavorite,
        filterName: item.filterName
      },
      updateSavedFilterDialog: true
    });
  }

  /**
   * Updates filter after some action
   *
   * @param allFilters
   */
  updateFilterData = (allFilters: FILTER[]) => {
    this.setState({ allFilters });
  };

  render() {
    const { allFilters = [] } = this.state;
    return (<>
        {
          !!allFilters.length && <div
            className={'tp-dropdown-header tp-favorite-header k-hbox k-align-items-center k-justify-content-between'}>
            <ul className={'tp-saved-filter-content k-reset'}>
              {allFilters.map((currentSavedFilter: any) => {
                const isFavorite = currentSavedFilter.isFavorite;
                return (
                  <li
                    className="tp-favorite-filter-list-item k-hbox k-align-items-center tp-pointable"
                    key={currentSavedFilter.filterName}
                  >
                    <PuzzleButton
                      aria-label={this.translate('SRL-toggleVisibleOnDashboard', { filterName: currentSavedFilter.filterName })}
                      titleText={this.translate('SRL-favoriteFilter')}
                      iconClass={'tp-icon tp-dashboard'}
                      fillMode={"flat"}
                      role="checkbox"
                      aria-checked={!!isFavorite}
                      themeColor={currentSavedFilter.isFavorite ? 'success' : null}
                      onClick={this.saveToLandingPage.bind(this, currentSavedFilter)}
                      tooltipPosition={'bottom'}
                      withTooltip
                    />
                    <div className={"tp-favorite-record-name"}
                         onClick={this.onFilterNameClick.bind(this, currentSavedFilter)}>
                      {currentSavedFilter.filterName}
                    </div>
                    <div className="tp-icon-holder">
                      <PuzzleButton
                        aria-label={this.translate('SRL-editFavoriteFilter', { filterName: currentSavedFilter.filterName })}
                        titleText={this.translate('SRL-editFavoriteFilter')}
                        className="right-icon"
                        fillMode={'flat'}
                        iconClass="tp-icon tp-edit"
                        onClick={this.editFilter.bind(this, currentSavedFilter)}
                        tooltipPosition={'left'}
                        withTooltip
                      />
                      <PuzzleButton
                        aria-label={this.translate('SRL-deleteFavoriteFilter', { filterName: currentSavedFilter.filterName })}
                        titleText={this.translate('SRL-deleteFavoriteFilter')}
                        className="right-icon"
                        fillMode={'flat'}
                        iconClass="tp-icon tp-delete"
                        onClick={this.deleteFilter.bind(this, currentSavedFilter)}
                        tooltipPosition={'left'}
                        withTooltip
                      />
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        }
      </>
    );
  }
}

export default SavedFiltersDialog;
